import React from "react";
import {Card} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import useToken from "../useToken";

class CardTotales extends React.Component{
    constructor(props) {
        let datos_inv = useToken.getDatos()
        super(props);
        this.state={
            inv: 0,
            invimp: 0,
            teo: 0,
            teoimp: 0,
            dif: 0,
            difimp: 0,
            titulo_columna : (datos_inv.app === 'sodimac'? 'costo':'importe'),
        }

    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            inv: nextProps.datos.inv,
            invimp: nextProps.datos.invimp,
            teo: nextProps.datos.teo,
            teoimp: nextProps.datos.teoimp,
            dif: nextProps.datos.dif,
            difimp: nextProps.datos.difimp,
        }, )


    }

    render() {
        return(
            <Card style={{background:'#dbe9fc'}} >
                <CardContent>
                    <Grid container spacing={2} alignItems={'center'}>
                        <Grid item xs={2}>
                            Inv. cantidad:  {new Intl.NumberFormat("de-DE").format(this.state.inv)}
                        </Grid>
                        <Grid item xs={2}>
                            Teo. cantidad: {new Intl.NumberFormat("de-DE").format(this.state.teo)}
                        </Grid>
                        <Grid item xs={2}>
                            Dif. cantidad: {new Intl.NumberFormat("de-DE").format(this.state.dif)}
                        </Grid>
                        <Grid item xs={2}>
                            Inv. {this.state.titulo_columna}: {new Intl.NumberFormat("de-DE").format(this.state.invimp)}
                        </Grid>
                        <Grid item xs={2}>
                            Teo.  {this.state.titulo_columna}: {new Intl.NumberFormat("de-DE").format(this.state.teoimp)}
                        </Grid>
                        <Grid item xs={2}>
                            Dif.  {this.state.titulo_columna}: {new Intl.NumberFormat("de-DE").format(this.state.difimp)}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        )
    }
}

export default CardTotales